"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var YEAR_MONTH_DAY_SEASON = /^\s*([1-2][0-9]{3})(?:\/([0-1][0-9]))?(?:\/([0-3][0-9]))?(?:\/(spring|summer|fall|winter))?.*$/i;
var seasons = new Map([
    ['spring', '1'],
    ['summer', '2'],
    ['fall', '3'],
    ['winter', '4'],
]);
function default_1(input) {
    input = typeof input === 'number' ? input.toString() : input;
    var matches = input.match(YEAR_MONTH_DAY_SEASON);
    if (!matches) {
        throw new Error('Date string could not be parsed');
    }
    var _a = __read(matches, 5), year = _a[1], month = _a[2], day = _a[3], season = _a[4];
    return __assign({ 'date-parts': [
            __spread([year], (month ? [month] : []), (day ? [day] : [])),
        ] }, (season ? { season: seasons.get(season.toLowerCase()) } : {}));
}
exports.default = default_1;
